// 실시간 데이터 datagrid
export const UI_1_1_tableRow1 = [
  [
    {
      cellName: "날짜",
      id: "date",
      row: 1,
      col: 1,
    },
    {
      cellName: "시간",
      id: "time",
      row: 1,
      col: 1,
    },
    {
      cellName: "에너지종류",
      id: "energy",
      row: 1,
      col: 1,
    },
    {
      cellName: "사용/공급",
      id: "method",
      row: 1,
      col: 1,
    },
    {
      cellName: "단위",
      id: "unit",
      row: 1,
      col: 1,
    },
    {
      cellName: "산업단지명",
      id: "complexName",
      row: 1,
      col: 1,
    },
    {
      cellName: "실제공급량",
      id: "actualSupply",
      row: 1,
      col: 1,
    },
    {
      cellName: "예측공급량",
      id: "predictedSupply",
      row: 1,
      col: 1,
    },
  ]
];

// 일일 데이터 datagrid
export const UI_1_1_tableRow2 = [
  [
    {
      cellName: "날짜",
      id: "date",
      row: 1,
      col: 1,
    },
    {
      cellName: "에너지종류",
      id: "energy",
      row: 1,
      col: 1,
    },
    {
      cellName: "사용/공급",
      id: "method",
      row: 1,
      col: 1,
    },
    {
      cellName: "단위",
      id: "unit",
      row: 1,
      col: 1,
    },
    {
      cellName: "산업단지명",
      id: "complexName",
      row: 1,
      col: 1,
    },
    {
      cellName: "실제공급량",
      id: "actualSupply",
      row: 1,
      col: 1,
    },
    {
      cellName: "예측공급량",
      id: "predictedSupply",
      row: 1,
      col: 1,
    },
    {
      cellName: "예측정확도(%)",
      id: "predictionAccuracy",
      row: 1,
      col: 1,
    },
  ]
];

// 데이터가 없어 임시로 보여주기 위한 하드코딩
export const UI_1_1_gridData1 = [
  {
    year: "2024.01.15",
    time: "13:45 ~ 14:00",
    energy: "압축공기",
    method: "공급",
    unit: "N㎥",
    complexName: "시화도금단지",
    companyName: "조합공용",
    plantName: "조합공용",
    actualSupply: "-",
    predictedSupply: "92",
  },
  {
    year: "2024.01.15",
    time: "13:45 ~ 14:00",
    energy: "압축공기",
    method: "공급",
    unit: "N㎥",
    complexName: "시화도금단지",
    companyName: "조합공용",
    plantName: "조합공용",
    actualSupply: "-",
    predictedSupply: "92",
  },
];

// 데이터가 없어 임시로 보여주기 위한 하드코딩
export const UI_1_1_gridData2 = [
  {
    year: "2024.01.16",
    energy: "압축공기",
    method: "공급",
    unit: "N㎥",
    complexName: "시화도금단지",
    companyName: "조합공용",
    plantName: "조합공용",
    actualSupply: "-",
    predictedSupply: "1390",
    predictionAccuracy: "-"
  },
  {
    year: "2024.01.15",
    energy: "압축공기",
    method: "공급",
    unit: "N㎥",
    complexName: "시화도금단지",
    companyName: "조합공용",
    plantName: "조합공용",
    actualSupply: "850",
    predictedSupply: "1360",
    predictionAccuracy: "62.50%"
  },
  {
    year: "2024.01.14",
    energy: "압축공기",
    method: "공급",
    unit: "N㎥",
    complexName: "시화도금단지",
    companyName: "조합공용",
    plantName: "조합공용",
    actualSupply: "304",
    predictedSupply: "320",
    predictionAccuracy: "94.97%"
  },
  {
    year: "2024.01.13",
    energy: "압축공기",
    method: "공급",
    unit: "N㎥",
    complexName: "시화도금단지",
    companyName: "조합공용",
    plantName: "조합공용",
    actualSupply: "545",
    predictedSupply: "570",
    predictionAccuracy: "95.68%"
  },
];